/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export class MenuPrintConfiguration extends DaoModel {
  constructor(guid, menu, showProductDescription, showProductFeature, showProductPrice,
    showSectionFreeText, showInTwoColumns, fontSize, lineProductHeight, clausesHeight,
    sectionsHeight, sectionsHeightTitle, featuresSize, showBorders, repeatLogoPerPage,
    showInformationText) {
    super(guid);
    this.showProductDescription = showProductDescription;
    this.showProductFeature = showProductFeature;
    this.showProductPrice = showProductPrice;
    this.showSectionFreeText = showSectionFreeText;
    this.showInTwoColumns = showInTwoColumns;
    this.showBorders = showBorders;
    this.fontSize = fontSize;
    this.lineProductHeight = lineProductHeight;
    this.clausesHeight = clausesHeight;
    this.sectionsHeight = sectionsHeight;
    this.sectionsHeightTitle = sectionsHeightTitle;
    this.featuresSize = featuresSize;
    this.menu = menu;
    this.repeatLogoPerPage = repeatLogoPerPage;
    this.showInformationText = showInformationText;
  }

  static toInstance(props = {}) {
    return new MenuPrintConfiguration(props.guid, props.menu, props.show_product_description,
      props.show_product_feature, props.show_product_price, props.show_section_free_text,
      props.show_in_two_columns, props.font_size, props.line_product_height, props.clauses_height,
      props.sections_height, props.sections_height_title, props.features_size,
      props.show_borders, props.repeat_logo_per_page, props.show_information_text);
  }

  serialize() {
    return {
      ...super.serialize(),
      show_product_description: this.showProductDescription,
      show_product_feature: this.showProductFeature,
      show_product_price: this.showProductPrice,
      show_section_free_text: this.showSectionFreeText,
      show_in_two_columns: this.showInTwoColumns,
      show_borders: this.showBorders,
      font_size: this.fontSize,
      line_product_height: this.lineProductHeight,
      clauses_height: this.clausesHeight,
      sections_height: this.sectionsHeight,
      sections_height_title: this.sectionsHeightTitle,
      features_size: this.featuresSize,
      menu: this.menu,
      repeat_logo_per_page: this.repeatLogoPerPage,
      show_information_text: this.showInformationText
    };
  }
}
